Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.DateTimeRange = (function () {

    function DateTimeRange () {

        Monet.UI.Fields.DateTimeField.apply (this, arguments);

        this.value = {
            ini: '',
            fin: ''
        };

        this.createElement = function () {


            this.inputIni = this.inputIni || document.createElement('input');
            this.inputFin = this.inputFin || document.createElement('input');

            this.inputIni.type = 'text';
            this.inputIni.className = 'dateTimeField';

            this.inputFin.type = 'text';
            this.inputFin.className = 'dateTimeField';

            if(this.maxSize){
                this.inputIni.maxLength = this.maxSize;
                this.inputFin.maxLength = this.maxSize;
            }

            this.setValue(this.value);

            this.rootEl.appendChild (this.inputIni);
            this.rootEl.appendChild (this.inputFin);

        };

        this.getValue = function () {
            return this.getFilterValue();
        };

        this.isEmpty = function () {
            return !(this.getValue() && this.getValue().ini && this.getValue().fin);
        };

        this.getFilterValue = function () {

            var result = {
                ini: '',
                fin: ''
            };

            if (this.inputIni && this.inputFin) {
                result.ini = Monet.Format.DateTime.parseLocaleToISOString(this.inputIni.value);
                result.fin = Monet.Format.DateTime.parseLocaleToISOString(this.inputFin.value);
            }
            return result;

        };

        this.setValue = function (value) {
            if (value) {
                this.value.ini = value.ini;
                this.value.fin = value.fin;
                this.setInputValue();
            }
        };

        this.setInputValue = function () {
            if(this.inputIni &&  this.inputFin) {
                this.inputIni.value = Monet.Format.DateTime.formatToLocale(this.value.ini);
                this.inputFin.value = Monet.Format.DateTime.formatToLocale(this.value.fin);
            }
        };

        this.clear = function () {
            this.setValue({
                ini: '',
                fin: ''
            });
        };

        this.initializeSpecialBehavior = function () {

            const monetDateFormat = Monet.I18n.locale.dateFormat.toLowerCase();
            this.jdDateFormat = monetDateFormat.replace("yyyy", "yy");

            const date = new Monet.Date.GeneralFunctions();
            const options = {};

            date.setDateTimePicker(this.inputFin, options);
            this.setListenerFocusOnEntityField(this.inputFin);
            
            options.beforeShow = options.onSelect = (input, dpInst) => {
                this.focusNext('button.ui-datepicker-close[data-handler="hide"]', dpInst);
            };

            date.setDateTimePicker(this.inputIni, options);
            this.setListenerFocusOnEntityField(this.inputIni);
        };

        this.disable = function () {
            this.inputIni.disabled = true;
            this.inputFin.disabled = true;
        };

        this.enable = function () {
            this.inputIni.disabled = false;
            this.inputFin.disabled = false;
        };

    }

    return DateTimeRange;

}());